<div
  aria-label="Page Footer Section"
  class="container"
  *ngIf="prequalFooter$ | async as prequalFooter"
>
  <div class="px-1">
    <nav class="px-0">
      <ul id="footer_links_container" class="row list-unstyled">
        <li
          class="col-12 col-md-auto py-md-0 mx-0 br-solid"
          *ngFor="
            let footerLink of prequalFooter.links;
            let last = last;
            let i = index
          "
          [ngClass]="{ 'br-solid ': !last }"
        >
          <a
            *ngIf="footerLink.url"
            attr.aria-label="{{ footerLink.label }}"
            target="_blank"
            href="{{ footerLink.url }}"
            role="button"
            class="footer-links"
            id="footer_link{{ i }}"
            tabindex="0"
          >
            <span>{{ footerLink.label }}</span>
          </a>
          <span
            *ngIf="!footerLink.url"
            class="footer-links text-decoration-none"
            id="nmls_id"
            >{{ footerLink.name }}</span
          >
        </li>
      </ul>
    </nav>
    <p
      role="note"
      class="footer-links text-decoration-none text-transform-none"
      id="cali_reserve_disc"
    >
      {{ prequalFooter.license }}
    </p>
    <p
      role="note"
      class="footer-links text-decoration-none text-transform-none"
      id="rights_reserve_disc"
    >
      © {{ currentYear }} {{ prequalFooter.copyright }}
    </p>
  </div>
</div>
